var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNegativo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.932,
    height: 70.175,
    viewBox: "0 0 211.932 70.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_filcasa_negativo",
    "data-name": "logo filcasa negativo",
    transform: "translate(-749.935 -580.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_246",
    "data-name": "Raggruppa 246",
    transform: "translate(749.935 599.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_220",
    "data-name": "Tracciato 220",
    d: "M841.9,618.383a.72.72,0,0,1-.27.663,6.8,6.8,0,0,1-3.926,1.478,2.206,2.206,0,0,1-2.428-2.491c0-3.032,3.152-4.512,6.2-5.856.4-.173.421.1.421.39Zm11.728,3.375c-.049-.15-.51-1.484-.563-1.647s-.242-.178-.42.01a3.449,3.449,0,0,1-2.369,1.218s-.6.036-.6-.377V607.634c0-2.664.4-8.362-7.347-8.362-7.649,0-13.969,6.276-13.969,8.976,0,3.819,2.488,3.9,3.687,3.9a4.232,4.232,0,0,0,3.944-4.505,18.319,18.319,0,0,0-.364-2.466c0-1.8,2.3-3.2,4.265-3.2a1.821,1.821,0,0,1,1.978,2.142c0,.63.018,4.632.018,4.846s0,.423-.247.528c-10.919,4.583-13.231,6.629-13.231,10.348a5.263,5.263,0,0,0,5.552,5.494c3.327,0,7.467-3.054,7.7-3.24s.639-.3.639-.023.466,2.96,4.415,2.96a10.5,10.5,0,0,0,6.8-2.8.392.392,0,0,0,.112-.476",
    transform: "translate(-699.323 -588.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_221",
    "data-name": "Tracciato 221",
    d: "M789.292,626.421s-1.1-.038-1.548-.086c-.635-.061-1.045-.917-1.045-1.341l.012-26.169v-6.292a.1.1,0,0,0-.1-.1c-3.357,0-8.115,2.521-10.909,2.521h-.673a.192.192,0,0,0-.193.191v1.494a.193.193,0,0,0,.087.161s1.9.882,2.335,1.035a.5.5,0,0,1,.337.515l.011,27.2c0,.421-.41.724-1.045.785-.449.048-1.43.086-1.43.086a.289.289,0,0,0-.29.29v1.978a.291.291,0,0,0,.29.288h14.155a.289.289,0,0,0,.288-.288v-1.978a.288.288,0,0,0-.288-.29",
    transform: "translate(-733.862 -592.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_222",
    "data-name": "Tracciato 222",
    d: "M777.48,603.837a.207.207,0,0,0-.013-.066l-2.113-10.577a.288.288,0,0,0-.29-.288H750.223a.287.287,0,0,0-.288.288v1.562a.287.287,0,0,0,.288.289l2.29.165a.8.8,0,0,1,.785.794l.013,29.469a.8.8,0,0,1-.8.785l-2.289.086a.29.29,0,0,0-.29.291v1.751a.29.29,0,0,0,.29.289h16.125a.291.291,0,0,0,.29-.289v-1.751a.291.291,0,0,0-.29-.291l-2.272-.086a.8.8,0,0,1-.786-.8V611.406a.226.226,0,0,1,.23-.224h2.04a5.792,5.792,0,0,1,5.786,5.841.289.289,0,0,0,.288.289h1.208a.289.289,0,0,0,.288-.289V603.25a.287.287,0,0,0-.288-.29h-1.208a.287.287,0,0,0-.288.29,5.792,5.792,0,0,1-5.786,5.841h-2.04a.227.227,0,0,1-.23-.225V596.731c0-.9.382-1.7,1.142-1.7l3.269,0c2.549,0,8.117,8.885,8.12,8.885a.17.17,0,0,0,.145.082h1.346a.168.168,0,0,0,.168-.166",
    transform: "translate(-749.935 -592.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_223",
    "data-name": "Tracciato 223",
    d: "M771.384,602.03a4.562,4.562,0,1,0-4.563-4.563,4.564,4.564,0,0,0,4.563,4.563",
    transform: "translate(-739.037 -592.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_224",
    "data-name": "Tracciato 224",
    d: "M779.361,621.945s-.979-.038-1.428-.086c-.637-.061-1.047-.916-1.047-1.341l.011-14.871v-6.18a.093.093,0,0,0-.1-.092c-3.345,0-6.723,2.4-10.178,2.4h-.673a.194.194,0,0,0-.191.194v1.492a.19.19,0,0,0,.087.161s1.9.883,2.335,1.035a.507.507,0,0,1,.337.517l.011,15.9c0,.421-.41.724-1.046.785-.449.048-1.428.086-1.428.086a.289.289,0,0,0-.29.29v1.978a.291.291,0,0,0,.29.288h13.3a.291.291,0,0,0,.29-.288v-1.978a.289.289,0,0,0-.29-.29",
    transform: "translate(-739.722 -587.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_225",
    "data-name": "Tracciato 225",
    d: "M807.647,615.666c-.193-.089-1.025-.49-1.088-.52s-.107-.025-.194.105c0,0-2.289,4.214-6.586,4.214s-7.041-3.86-7.041-9.6c0-4.306,1.224-8,5.609-8,1.12,0,1.765.545,1.765,1.256,0,2.228-.708,1.468-.708,4.174a4.146,4.146,0,0,0,4.321,4.258c2.983,0,3.951-2.5,3.951-4.258s-1.477-8.052-10.247-8.052c-7.646,0-13.221,6.807-13.221,13.286,0,7.536,5.7,12.9,12.327,12.9s10.086-4.752,11.368-9.362c.052-.187-.062-.311-.257-.4",
    transform: "translate(-727.816 -588.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_226",
    "data-name": "Tracciato 226",
    d: "M821.852,603.9c0-1.427,1.273-1.938,2.7-1.938s5,1.071,7.139,6.308c.148.367.191.5.451.5h1.167c.186,0,.275-.064.275-.318s-.477-6.731-.477-6.975a.449.449,0,0,0-.294-.5,16.613,16.613,0,0,0-7.291-1.7c-4.051,0-9.673,2.142-9.673,8.464,0,6.856,13.243,7.927,13.243,12.083,0,0,.561,3.11-3.009,3.11-3.722,0-6.6-2.613-8.36-8.164-.114-.357-.186-.349-.408-.349h-1.2c-.158,0-.266.074-.266.285v8.115c0,.26.123.334.344.433a26.475,26.475,0,0,0,9.382,2.133c4.535,0,9.889-2.476,9.889-8.187,0-9.917-13.61-8.9-13.61-13.306",
    transform: "translate(-707.397 -588.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_227",
    "data-name": "Tracciato 227",
    d: "M813.27,618.383a.724.724,0,0,1-.27.663,6.82,6.82,0,0,1-3.929,1.479,2.208,2.208,0,0,1-2.429-2.493c0-3.032,3.154-4.512,6.208-5.856.395-.173.42.1.42.39Zm11.165,1.728c-.051-.164-.243-.178-.42.01a3.459,3.459,0,0,1-2.373,1.218s-.6.036-.6-.377V607.634c0-2.662.4-8.362-7.347-8.362-7.648,0-13.971,6.276-13.971,8.976,0,3.82,2.489,3.9,3.689,3.9a4.229,4.229,0,0,0,3.942-4.5,18.4,18.4,0,0,0-.364-2.468c0-1.8,2.305-3.2,4.266-3.2a1.822,1.822,0,0,1,1.979,2.142c0,.629.018,4.63.018,4.844s0,.423-.25.528c-10.917,4.583-13.23,6.629-13.23,10.348a5.266,5.266,0,0,0,5.553,5.5c3.329,0,7.465-3.055,7.7-3.241s.64-.3.64-.021.466,2.958,4.413,2.958a10.509,10.509,0,0,0,6.8-2.8.394.394,0,0,0,.112-.476c-.051-.15-.51-1.484-.563-1.647",
    transform: "translate(-717.801 -588.028)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_228",
    "data-name": "Tracciato 228",
    d: "M831.679,580.972h51.166l26.268,26.686H857.945Z",
    transform: "translate(52.755)",
    fill: "#00853f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_229",
    "data-name": "Tracciato 229",
    d: "M844.156,587.382,825.72,605.973h-8.069l22.49-22.677Z",
    transform: "translate(43.702 1.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_81",
    "data-name": "Rettangolo 81",
    width: 48.171,
    height: 38.181,
    transform: "translate(911.693 612.765)",
    fill: "#00853f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_247",
    "data-name": "Raggruppa 247",
    transform: "translate(831.399 643.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_230",
    "data-name": "Tracciato 230",
    d: "M802.923,623.156c.308-.63.918-1.882.961-1.981l.3-.576.3.619c.2.418.686,1.405.948,1.938Zm.345-4.064-3.822,7.325H801.3l1.028-2.1H806l1.012,2.1h2.007l-3.788-7.325Z",
    transform: "translate(-799.446 -619.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_231",
    "data-name": "Tracciato 231",
    d: "M811.54,623.54h2.075v1.665a4.767,4.767,0,0,1-1.451.194,4.046,4.046,0,0,1-2.419-.661,2.539,2.539,0,0,1-.668-1.892,3.306,3.306,0,0,1,.39-1.614,2.632,2.632,0,0,1,2.447-1.028,5.049,5.049,0,0,1,2.223.509l.143.062.954-.842-.3-.169a6.237,6.237,0,0,0-3.047-.707,5.692,5.692,0,0,0-2.907.68,3.562,3.562,0,0,0-.345,5.935,6.026,6.026,0,0,0,3.424.9,8.646,8.646,0,0,0,3.1-.538l.151-.063v-3.6h-4.2Z",
    transform: "translate(-794.442 -619.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_232",
    "data-name": "Tracciato 232",
    d: "M842.956,619.092l-2.129,2.7c-.133.171-.26.334-.375.487-.123-.176-.257-.354-.359-.485l-2.1-2.7h-2.218l3.72,4.459v2.866h1.815V623.6l3.751-4.508Z",
    transform: "translate(-775.999 -619.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_233",
    "data-name": "Tracciato 233",
    d: "M836.224,624.965a4.5,4.5,0,0,1-1.986.416,3.032,3.032,0,0,1-2.658-1.14,2.223,2.223,0,0,1-.3-1.313,2.8,2.8,0,0,1,.41-1.675,2.713,2.713,0,0,1,2.427-1.068,4.274,4.274,0,0,1,1.922.4l.135.064,1.117-.86-.355-.174a6.4,6.4,0,0,0-2.8-.582c-2.741,0-4.73,1.586-4.73,3.771,0,2.21,1.907,3.753,4.637,3.753a8.138,8.138,0,0,0,3.068-.578l.375-.156-1.115-.925Z",
    transform: "translate(-780.115 -619.037)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_234",
    "data-name": "Tracciato 234",
    d: "M816.979,623.21h3.659v-1.2h-3.659v-1.72H821.3l.3-1.17h-6.4V626.4h6.486v-1.2h-4.7Z",
    transform: "translate(42.117 24.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_248",
    "data-name": "Raggruppa 248",
    transform: "translate(868.382 643.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_235",
    "data-name": "Tracciato 235",
    d: "M827.808,623.058c.007.369.031.78.057,1.14-.161-.232-.332-.47-.477-.651l-3.625-4.444h-1.841v7.305h1.818l-.066-4.206c-.006-.322-.021-.63-.043-.93.222.3.469.607.683.87l3.5,4.265h1.7V619.1h-1.755Z",
    transform: "translate(-821.923 -619.103)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNegativo);
export default __webpack_public_path__ + "static/media/logo-negativo.62b0b655b91cd26d330bd009562caecc.svg";
export { ForwardRef as ReactComponent };